import PubSubUtils from '../utils/pubsub-utils';
import CONSTANTS from '../constants';

class Debugger {
  #inspectorEnabled: boolean;
  #inspectorShowAll: boolean;

  public isPreview: boolean;
  public debugLevels: string;

  constructor() {
    this.#inspectorEnabled = localStorage.getItem('inspectorFlag') === 'true';
    this.#inspectorShowAll = false;
    this.isPreview = false;
    this.debugLevels = 'vcv=1;tracer=0;log=0;metric=1';
  }

  /**
   * This API toggles UI Inspector mode
   * @example <caption>PCore.getDebugger().toggleXRay(true)</caption>
   * @deprecated The toggleXRay method is deprecated. Please use the toggleInspector method going forward.
   */
  toggleXRay(enable: boolean) {
    console.warn('The toggleXRay method is deprecated. Please use the toggleInspector method going forward.');

    if (enable && !this.inspectorEnabled) {
      this.toggleInspector();
    }

    if (!enable && this.inspectorEnabled) {
      this.toggleInspector();
    }
  }

  get inspectorEnabled() {
    return this.#inspectorEnabled;
  }

  get inspectorShowAll() {
    return this.#inspectorShowAll;
  }

  /**
   * This API toggles UI Inspector mode
   * @example <caption>PCore.getDebugger().toggleInspector()</caption>
   */
  toggleInspector() {
    const storedInspectorFlag = localStorage.getItem('inspectorFlag') === 'true';
    this.#inspectorEnabled = !storedInspectorFlag;
    localStorage.setItem('inspectorFlag', this.#inspectorEnabled.toString());
    PubSubUtils.publish(CONSTANTS.PUB_SUB_EVENTS.UI_EVENTS.INSPECTOR, this.#inspectorEnabled);
  }

  /**
   * This API toggles the UI Inspector's show all mode
   * @example <caption>PCore.getDebugger().toggleInspectorShowAll()</caption>
   */
  toggleInspectorShowAll() {
    this.#inspectorShowAll = !this.#inspectorShowAll;
    PubSubUtils.publish(CONSTANTS.PUB_SUB_EVENTS.UI_EVENTS.INSPECTOR_SHOW_ALL, this.#inspectorShowAll);
  }

  /**
   * This API set the previewMode to true
   * @example <caption>PCore.getDebugger().setPreviewMode()</caption>
   */
  setPreviewMode() {
    this.isPreview = true;
  }

  /**
   * This API gets the current preview value
   * @example <caption>PCore.getDebugger().getPreviewMode()</caption>
   * @returns true/false
   * @private
   */
  getPreviewMode() {
    /* Add logic to identify the previewMode & InfinityX as backend */
    return this.isPreview;
  }

  /**
   * This API set the tracer flag as 1
   * @example <caption>PCore.getDebugger().enableTracer()</caption>
   * @private
   */
  enableTracer = () => {
    this.debugLevels = 'vcv=1;tracer=1;log=0;metric=1';
  };

  /**
   * This API set the tracer flag as 0
   * @example <caption>PCore.getDebugger().disableTracer()</caption>
   * @private
   */
  disableTracer = () => {
    this.debugLevels = 'vcv=1;tracer=0;log=0;metric=1';
  };

  getDebugLevels = () => {
    return this.debugLevels;
  };
}

export default new Debugger();
